import type { RxJsonSchema } from 'rxdb';
import type { EnvironmentalCondition } from './environmentalCondition.types';

export const environmentalConditionSchema: RxJsonSchema<EnvironmentalCondition> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'pkAreaRiskResult',
  properties: {
    pkAreaRiskResult: { type: 'string', maxLength: 36 },
    riskCategoryId: { type: ['number', 'null'] },
    riskTypeId: { type: ['number'] },
    riskTypeName: { type: 'string' },
    riskValue: { type: ['number', 'null'] },
    riskName: { type: 'string' },
    pkAreaRiskCategoryRankType: { type: ['number', 'null'] },
    areaId: { type: 'string' },
    dateModified: { type: ['string', 'null'] },
    site: { type: ['number'] },
  },
};
